// src/store/slices/uiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    loginModalOpen: false,
    loginModalReason: null,
  },
  reducers: {
    openLoginModal: (state, action) => {
      state.loginModalOpen = true;
      state.loginModalReason = action.payload || null;
    },
    closeLoginModal: (state) => {
      state.loginModalOpen = false;
      state.loginModalReason = null;
    },
  },
});

export const { openLoginModal, closeLoginModal } = uiSlice.actions;
export default uiSlice.reducer;
